import { t } from '../../i18next';
import { postRequest } from '../../shared/utils';
import { compareAddedRowObjects } from '../../shared/utils/commitHandlerHelper';

export const CommitHandler = async (props) => {
  const { addedRow, userDetails, initialValue, configSchema, tableDetails } = props;

  const resultSet = {
    success: true,
    errors: [],
  };

  const addObjArr = addedRow.map((item) => {
    const newItem = {
      ...item,
      screen_id: initialValue,
      created_by: userDetails.userId,
      updated_by: userDetails.userId,
      update_date: new Date().toISOString().substring(0, 19),
    };
    delete newItem.description;
    return newItem;
  });
  const insertObjects = compareAddedRowObjects(addObjArr);

  try {
    const result = await postRequest('/api/tables', {
      screenGridId: tableDetails.id,
      tables: [
        {
          schema: configSchema,
          table: 'mbd_roles_to_screens',
          pkey: tableDetails.mbdDataGrid.dataGridUniqueIdentifier,
          insertObjects,
        },
      ],
    });
    if (result?.errors) {
      resultSet.errors.push({
        message: t('error.update_failed_following', {
          msg: result?.errors[0]?.message,
        }),
      });
      resultSet.success = false;
    }
  } catch {
    resultSet.errors.push({
      message: t('exception_occurred'),
    });
    resultSet.success = false;
  }

  return resultSet;
};
